import { faCheck, faCopy } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Button, { ButtonGroup } from "../common/Button";
import Flow from "../common/Flow";
import Table from "../common/Table";
import Typography from "../common/Typography";

function AgentDetail({ store }) {
  const [isCopied, setCopied] = useState(false);
  const agent = store.state.agent;

  const copyTokenHandle = () => {
    navigator.clipboard
      .writeText(store.state.token)
      .then(() => {
        setCopied(true);
      })
      .catch(() => {
        alert('Something went wrong');
      });
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 1000);

    return () => clearTimeout(timeout);
  });

  return (
    <Flow $space={3}>
      <Typography as="h2" fontSize="xl">{agent && agent.symbol}</Typography>
      <Table>
        <tbody>
          <tr>
            <td>Headquarters</td>
            <td>{agent && agent.headquarters}</td>
          </tr>
          <tr>
            <td>Faction</td>
            <td>{agent && agent.startingFaction}</td>
          </tr>
        </tbody>
      </Table>
      <ButtonGroup>
        <Button onClick={ () => store.logout() }>Logout</Button>
        <Button onClick={ () => copyTokenHandle() }><FontAwesomeIcon icon={isCopied ? faCheck : faCopy} /> Copy token</Button>
      </ButtonGroup>
    </Flow>
  )
}

export default AgentDetail;
